/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { FormErrors } from '../interfaces';

export const isValid = <T>(validateFn: (data: T) => FormErrors<T>, data: T) => {
    const errors = validateFn(data);
    return Object.keys(errors).length === 0;
};
